const materialType = {
    labelKey: 'products.contactLenses.materialType',
    attribute: 'materialType'
};
const lensType = {
    labelKey: 'products.contactLenses.lensType',
    attribute: 'lensType'
};
const clMaterial = {
    labelKey: 'products.contactLenses.material',
    attribute: 'material'
};
const waterContent = {
    labelKey: 'products.contactLenses.waterContent',
    attribute: 'waterContent'
};
const packageQuantity = {
    labelKey: 'products.contactLenses.boxQuantity',
    attribute: 'packageQuantity'
};
const opcoBackendId = {
    labelKey: 'products.specifications.opcoBackendId',
    attribute: 'opcoBackendId'
};
const erpID = {
    labelKey: 'products.specifications.erpId',
    attribute: 'erpId'
};
const lensTypeTarget = {
    labelKey: 'products.solutions.lensTypeTarget',
    attribute: 'lensTypeTarget'
};
const caseIncluded = {
    labelKey: 'products.solutions.caseIncluded',
    attribute: 'caseIncluded'
};
const minimumCycleTime = {
    labelKey: 'products.solutions.minimumCycleTime',
    attribute: 'minimumCycleTime'
};
const preservativeFree = {
    labelKey: 'products.solutions.preservativeFree',
    attribute: 'preservativeFree'
};
const maxTimeFrameInLensCase = {
    labelKey: 'products.solutions.maxTimeFrameInLensCase',
    attribute: 'maxTimeFrameInLensCase'
};
const expirationAfterOpening = {
    labelKey: 'products.solutions.expirationAfterOpening',
    attribute: 'expirationAfterOpening'
};
const lensColor = {
    labelKey: 'products.specifications.lensColor',
    attribute: 'lensColor'
};
const frameColor = {
    labelKey: 'products.specifications.frameColor',
    attribute: 'frameColor'
};
const accessoryColor = {
    labelKey: 'products.specifications.accessoryColor',
    attribute: 'accessoryColor'
};
const accessoryType = {
    labelKey: 'products.specifications.accessoryType',
    attribute: 'accessoryType'
};
const frameMaterial = {
    labelKey: 'products.specifications.frameMaterial',
    attribute: 'frameMaterial'
};
const material = {
    labelKey: 'products.specifications.material',
    attribute: 'material'
};
const frameShape = {
    labelKey: 'products.specifications.frameShape',
    attribute: 'frameShape'
};
const frameType = {
    labelKey: 'products.specifications.frameType',
    attribute: 'frameType'
};
const gender = {
    labelKey: 'products.specifications.gender',
    attribute: 'gender'
};
const articleNumber = {
    labelKey: 'products.specifications.articleNumber',
    attribute: 'articleNumber'
};
const roadworthiness = {
    labelKey: 'products.specifications.roadworthiness',
    attribute: 'roadworthiness',
    labelPrefix: 'products.specifications.roadworthiness.'
};
const brand = {
    labelKey: 'products.specifications.brand',
    attribute: 'brand'
};
const templeType = {
    labelKey: 'products.specifications.templeType',
    attribute: 'templeType'
};
const opcoBackendIdArticleNumber = {
    labelKey: 'products.specifications.articleNumber',
    attribute: 'opcoBackendId'
};
const supplierEAN = {
    labelKey: 'products.specifications.ean',
    attribute: 'supplierEAN'
};
const polarized = {
    labelKey: 'products.sunglasses.features.polarized',
    attribute: 'polarized'
};
const prescriptionGlass = {
    labelKey: 'products.specifications.prescriptionGlass',
    attribute: 'prescriptionGlass'
};
const trend = {
    labelKey: 'products.specifications.trend',
    attribute: 'trend'
};
const sku = {
    labelKey: 'products.specifications.sku',
    attribute: 'sku'
};
const replacementFrequency = {
    labelKey: 'products.contactLenses.replacementFrequency',
    attribute: 'replacementFrequency'
};
const brandModelCode = {
    labelKey: 'products.specifications.brandModelCode',
    attribute: 'brandModelCode'
};
const glazeble = {
    labelKey: 'products.specifications.glazeable',
    attribute: 'glazeble'
};
const packageOption = {
    labelKey: 'products.solutions.packageOption',
    attribute: 'packageOption'
};
const templeColor = {
    labelKey: 'products.specifications.templeColor',
    attribute: 'templeColor'
};
const faceShape = {
    labelKey: 'products.specifications.faceShape',
    attribute: 'faceShape'
};

export { accessoryColor, accessoryType, articleNumber, brand, brandModelCode, caseIncluded, clMaterial, erpID, expirationAfterOpening, faceShape, frameColor, frameMaterial, frameShape, frameType, gender, glazeble, lensColor, lensType, lensTypeTarget, material, materialType, maxTimeFrameInLensCase, minimumCycleTime, opcoBackendId, opcoBackendIdArticleNumber, packageOption, packageQuantity, polarized, prescriptionGlass, preservativeFree, replacementFrequency, roadworthiness, sku, supplierEAN, templeColor, templeType, trend, waterContent };
//# sourceMappingURL=library.js.map
